jQuery( document ).ready(function() {
    /**
    * Offers swiper settings
    */
    var tabsSwiper = new Swiper(".tabsSwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: ".tabsNext",
        prevEl: ".tabsPrev",
      },
      pagination: {
        el: ".tabsPagination",
        clickable: true,
        renderBullet: function (index, className) {
          var name = "";
          switch (index) {
            case 0:
              name = "SCIENCE-BACKED";
              textDirection = "style='text-align: start;'";
              break;
            case 1:
              name = "100% NATURAL";
              textDirection = "style='text-align: center;'";
              break;
            case 2:
              name = "ULTRA CLEAN";
              textDirection = "style='text-align: end;'";
              break;
          }
  
          return '<span class="w-[104px] sm:w-52 xl:w-64 h-14 sm:h-12 text-base xl:text-2xl ' + className + '"' + textDirection +  '>' + name + "</span>";
        }
      },
    });

    /**
    * Stories swiper settings
    */
    var storiesSwiper = new Swiper(".storiesSwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: ".storiesNext",
        prevEl: ".storiesPrev",
      },
      pagination: {
        el: ".storiesPagination",
        clickable: true,
      },
      breakpoints: {
        1440: {
          slidesPerView: 2,
          spaceBetweenSlides: 30,
        },
      }
    });


    /**
    * Comparison slider thumbnail images swiper settings
    */
    var sliderThumbsSwiper = new Swiper(".sliderThumbsSwiper", {
      slidesPerView: 3,
      spaceBetween: 1,
      navigation: {
        nextEl: ".sliderThumbsNext",
        prevEl: ".sliderThumbsPrev",
      },
    });

    /**
    * Offers swiper settings
    */
    var offersSwiper = new Swiper(".offersSwiper", {
      slidesPerView: "auto",
      initialSlide: 1,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: ".offersNext",
        prevEl: ".offersPrev",
      },
    });

    /**
     * Widescreen hero section scroll down button
     */
    jQuery(document).on('click', '#heroScroll', function () {
      var scrollDiv = document.getElementById("heroScrollAnchor").getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
    });

    /**
    * Comparison slider gallery thumbnail change
    */
    jQuery(document).on('click', '.sliderThumb', function () {
      var expandImg = document.getElementById("expandedImg");
      var expandImg2 = document.getElementById("expandedImg2");
      var imgText = document.getElementById("tabImgText");
      // var fileNameIndex = this.src.lastIndexOf("/") + 1;
      // var filename = this.src.substr(fileNameIndex);

      imgText.innerHTML = this.dataset.text;

      expandImg.src = this.src;
      expandImg.parentElement.style.display = "block";

      expandImg2.src = this.src.replace(/\d+/g, "30")
      expandImg2.parentElement.style.display = "block";
    });

    /**
    * E-book gallery thumbnail change
    */
    jQuery(document).on('click', '.ebookThumb', function () {
      var expandImg = document.getElementById("ebookMain");

      expandImg.src = this.src;
      expandImg.parentElement.style.display = "block";
    });

    /**
    * E-book gallery lightbox functions
    */
    var modal = document.getElementById("lightbox");
    var modalImg = document.getElementById("modal-img");

    function showLightbox(img) {
      modal.classList.remove('hidden');
      modal.classList.add('flex');
      modalImg.src = img.src;
    }

    jQuery(document).on('click', '.ligtbox-close', function () {
      modal.classList.remove('flex');
      modal.classList.add('hidden');
    });

    /**
     * Modal window "Learn more" scroll to element
     */
    jQuery(document).on('click', '.modal-scroll', function () {
      anchor = this.id + 'Anchor';
      modal = document.querySelector('.uk-open');
      target = modal.querySelector('.' + anchor);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /**
    * Show more/less buttons logic
    */
    jQuery(document).on('click', '.show-more-less', function () {
      var dots = this.parentElement.querySelector('.dots');
      var moreText = this.parentElement.querySelector('.more');
      var btnText = this;

      if (dots.style.display === "none") {
          dots.style.display = "inline";
          btnText.innerHTML = "show more";
          moreText.style.display = "none";
      } else {
          dots.style.display = "none";
          btnText.innerHTML = "show less";
          moreText.style.display = "block";
      }
    });
});